{
  "Mon": "Pondělí",
  "Tue": "Úterý",
  "Wed": "Středa",
  "Thu": "Čtvrtek",
  "Fri": "Pátek",
  "Sat": "Sobota",
  "Sun": "Neděle",
  "CORE": {
    "notificationDateFormat": "d/M/yy",
    "update": "Loading...",
    "youAreOffline": "Device offline! Connect to a network and try again later!",
    "comeBack": "{{icon}} your skis are waiting for you",
    "help": "Nápověda",
    "notification": {
      "ok": "Chápu"
    },
    "skiHire": "Půjčovna lyží"
  },
  "ALPINSKIHIRE": {
    "AR": {
      "start": {
        "selectBookingParametersFact3": "Plaťte ve své vlastní měně! Náklady na výměnu vaší měny uhradí Alpy.com. Sazby aktualizujeme každý den.",
        "searchHeadline": "Kde byste si chtěli půjčit lyže nebo snowboard?"
      },
      "showTownReserveEarlyEnoughInfo": "Upozorňujeme, že v sezóně může být v obchodech nedostatek vybavení. Doporučujeme zarezervovat si ho předem.",
      "shop_filter_distance_to_center": "<strong>Vzdálenost</strong> od centra města: <strong><span id='range'>{{ distance }} </span>km</strong>",
      "shopSearch": {
        "formSearchButtonLabel": "HLEDAT",
        "promocode": {
          "couponCodeIsInCart": "Kupón s kódem {{ code }} byl přidán do vašeho košíku a bude započten před dokončením objednávky.",
          "typePromo": "Promo",
          "typeCoupon": "Kupón"
        }
      }
    },
    "offer": {
      "title": "Proč si zarezervovat své lyže přes {{ platformname }}"
    },
    "start": {
      "advantagesHeadline": "Zaručeně nejlepší ceny půjčení lyží ve díky online rezervaci",
      "listedBrands": "Dostupné značky",
      "topTowns": "Nejlepší půjčovny lyží"
    },
    "sidebar": {
      "hotlineItalic": "Dovolte nám pomoci vám!",
      "callNow": "Volejte hned na: ",
      "hotline": "Hotline"
    },
    "shopSearch": {
      "validation": {
        "selectAgeForEveryChild": "Uveďte, prosím, věk každého dítěte (věk na začátku výpůjčky)",
        "onePersonRequired": "vyberte alespoň jednu osobu",
        "enterTown": "Vyberte, prosím, lyžařské středisko"
      },
      "minified": {
        "users": "dospělí: {{ number_adults }}, děti: {{ number_children }}",
        "date": "{{ start_date }} – {{ end_date }}",
        "dateFormat": "EEEEEE d/M/yy"
      },
      "datePickerDisplayFormat": "EEEEEE d/M/yy",
      "datePickerPreviousMessage": "Vybavení můžete vyzvednout v obchodě dne <span>{{ date }}</span> po 15:30. Noční lyžování není zahrnuto.",
      "datePickerPreviousMessageDateFormat": "d/M/yy",
      "formSearchLabel": "Středisko, obec, stát, název obchodu",
      "formSearchInfo": "Vyčkejte, prosím, hledáme odpovídající záznamy…",
      "formSearchResultDescription": "({{region}}, {{province}})",
      "formSearchResultShopNumber": "Obchody: {{ count }}",
      "formSearchResultShowAll": "Zobrazit všechny ({{ count }}) výsledky",
      "formSearchResultGroupLocations": "Obec",
      "formSearchResultGroupShops": "Obchodu",
      "formSearchResultGroupRegions": "Kraj",
      "formSearchResultGroupCountries": "Státy",
      "formSearchButtonLabelDelivery": "Od {{price}}",
      "deliverToHotel": "Chci, aby mi bylo vybavení doručeno do ubytování – ZDARMA!",
      "formStartDate": "1. den pronájmu",
      "formEndDate": "Poslední den pronájmu",
      "formNumberOfPeople": "Počet osob",
      "formAdultsLabel": "Dospělí",
      "formPeopleCount": {
        "numberOfPeople": "{{ number_adults }} {{ pluralizeAdult }} {{ number_children }} {{ pluralizeChildren }}",
        "adultNone": "dospělé",
        "adultSingle": "dospělého",
        "adultMultiple": "dospělé",
        "childNone": "děti",
        "childSingle": "dítě",
        "childMultiple": "děti"
      },
      "formAdultsLabelInfo": "osoby starší 18 let na začátku pronájmu",
      "formChildrenLabel": "Děti",
      "formChildrenLabelInfo": "osoby mladší 18 let na začátku pronájmu",
      "formChildInputLabelInfo": "Jak staré je vaše dítě? / Jak staré budou vaše děti na začátku pronájmu?",
      "formChildInputPlaceholder": "jak staré?",
      "formPromotionCode": "Propagační kód",
      "formPromotionCodeNotFound": "Tento propagační kód neexistuje.",
      "noResults": "Nebyly nalezeny žádné výsledky"
    },
    "navigation": {
      "skihire": "Půjčovna lyží",
      "skischool": "Lyžařské školy",
      "accommodation": "Ubytování",
      "aboutUs": "O nás",
      "helpCenter": "Centrum pomoci",
      "subnavBooking": "Rezervace",
      "subnavAdditionalOffers": "Další nabídky",
      "subnavGroupBooking": "Skupinové rezervace",
      "subnavTermsAndConditions": "Všeobecné obchodní podmínky",
      "subnavBecomePartner": "Stát se partnerem",
      "subnavPrivacyPolicy": "Zásady ochrany osobních údajů",
      "subnavHelp": "Kontakt",
      "myAlpinresorts": "Múj Alpy.com",
      "subnavLogin": "Přihlásit",
      "subnavLogout": "Logout",
      "subnavBookingsAndCancellations": "Objednávky a storna",
      "subnavPersonalSettings": "Osobní nastavení",
      "career": "Kariéra"
    },
    "geoIp": {
      "chooseACountry": "Vyberte, prosím, stát"
    }
  },
  "ALPINSTATIC": {
    "aboutUs": {
      "title": "O nás",
      "metaDescription": "Zde najdete všechny informace o týmu {{ productName }}. Svěřte se do péče největší sítě půjčoven lyží a lyžařských škol v Evropě!"
    },
    "imprint": {
      "title": "Právní informace – {{ productName }}",
      "metaDescription": "Impresum – {{ productName }}"
    },
    "privacy": {
      "title": "Podmínky ochrany osobních údajů {{ productName }}",
      "metaDescription": "Podmínky ochrany osobních údajů {{ productName }}"
    },
    "termsAndConditions": {
      "title": "Všeobecné obchodní podmínky | {{ productName }}",
      "metaDescription": "Všeobecné obchodní podmínky pro {{ productName }}"
    },
    "additionalOffers": {
      "title": "Další nabídky",
      "metaDescription": ""
    }
  },
  "ROUTES": {
    "CHECKOUT": {
      "PAYMENT": "payment",
      "CHECKOUT": "checkout"
    },
    "CANCELLATION": "storno-rezervace",
    "SKIHIREENTRY": "pujcovna-lyzi",
    "COUNTRIES": "staty",
    "PRODUCTS": "products",
    "PRODUCT": {
      "FINISH": "finish"
    },
    "SKIHIRE": {
      "GROUPS": "groups",
      "PRODUCTS": "products",
      "SEARCH": "hledat"
    },
    "SKISCHOOLENTRY": "lyzarska-skola",
    "STATIC": {
      "SWISSPASS": "swisspass",
      "IMPRINT": "impresum",
      "PRIVACYPOLICY": "zasady-ochrany-osobnich-udaju",
      "TERMSANDCONDITIONS": "podminky",
      "HELP": "napoveda",
      "ABOUTUS": "o-nas",
      "ADDITIONALOFFERS": "dalsi-nabidky",
      "HOWTO": "jak-na-to"
    }
  }
}